import {createAction} from '@reduxjs/toolkit';

import type {Channel} from '@mattermost/types/channels';

export const selectChannel = createAction<Channel['id']>('channels/actions/selectChannel');
